import React from 'react';
import { useMutation } from '@apollo/client';

import { Button, useFlashMessage } from '@indigo-ag/component-module';
import { AgFinancingPolls } from '@indigo-ag/schema';

import { NewPage } from 'core/components';
import { triggerPoll } from '../../adminQueries';
import { text } from 'shared/utils';

export const PollingPage: React.FunctionComponent = () => {
  const [triggerPollFn] = useMutation(triggerPoll);

  const { addFlashMessage } = useFlashMessage();

  const handleClick = (pollToTrigger: AgFinancingPolls) => () => {
    triggerPollFn({
      variables: {
        pollToTrigger
      }
    }).then(({ data }) => {
      if (!data || !data.triggerPoll) {
        addFlashMessage({
          content: `Poll ${pollToTrigger} in progress, unable to launch it at the moment...`,
          title: '',
          variant: 'error'
        });
      } else {
        addFlashMessage({
          content: `Starting poll ${pollToTrigger}...`,
          title: '',
          variant: 'success'
        });
      }
    });
  };

  return (
    <NewPage title="Salesforce Polling">
      {Object.keys(AgFinancingPolls).map(key => (
        <Button size="small" variant="secondary" onClick={handleClick(key as AgFinancingPolls)} key={key}>
          {text.toTitleCase(text.replaceUnderScoresWithSpaces(key))}
        </Button>
      ))}
    </NewPage>
  );
};
